import { useEffect, useState } from "react";

export function FadeIn({
  children,
  className,
  delayMs = 0,
}: {
  children: React.ReactNode;
  className?: string;
  delayMs?: number;
}) {
  const [show, setShow] = useState(false);
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        setReduced(mq.matches);
      } catch {}
    }
    const r = requestAnimationFrame(() => setShow(true));
    return () => cancelAnimationFrame(r);
  }, []);
  return (
    <div
      className={`transition-all duration-300 ${show || reduced ? "opacity-100 translate-y-0" : "opacity-0 translate-y-1"} ${className || ""} motion-reduce:transition-none motion-reduce:transform-none`}
      style={{ transitionDelay: `${delayMs}ms` }}
    >
      {children}
    </div>
  );
}

export default FadeIn;
